import React, { useEffect } from "react";
import { Banner } from "../../components";
import Vision from "./Vision";
import Description from "./Description";
import PageMeta from "../../seo/PageMeta";

const About = () => {
  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <div className="flex flex-col items-center w-full h-full">
      <PageMeta
        title="About Us"
        description="Learn about Clear Choice Cleaning Services, a trusted cleaning company in Melbourne, Australia, committed to quality and reliability."
        path="/about"
        image="/assets/images/banners/about.webp"
      />
      <Banner page="about" heading="About Us" />
      <Vision />
      <Description />
    </div>
  );
};

export default About;
